// extracted by mini-css-extract-plugin
module.exports = {"chat":"MessengerRoom_chat__1xzwC","forwards":"MessengerRoom_forwards__3JeZn","avatarWrap":"MessengerRoom_avatarWrap__3xEMb","messageWrap":"MessengerRoom_messageWrap__1epex"};